module.exports = __webpack_public_path__ + "img/combanner.f937ec5a.png";